import React from 'react';
import './RadioSelect.scss';

import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(theme => ({

}));

function RadioSelect(props) {

  const radioRef = React.createRef();

    const classes = useStyles();
    return (
        <React.Fragment>
            <FormControlLabel value={props.value} control={<Radio ref={radioRef} disabled={props.disabled}/>} label={props.label}/>
            {props.img ?
                <img onClick={()=>{
                    const radio = radioRef.current;
                    radio.click();
                }} className="radio-thumb" src={props.img} alt="test"/>
            : '' }
            
        </React.Fragment>
    );
}

export default RadioSelect;
